import { http } from "../../common/helpers/http";
import { baseUrl } from "../../common/config";
import { ApiResponse } from "../../models/api/api-response";

export interface Policy {
  policyTypeId: number;
  body: null | string;
  bodyEditor: null | string;
  version: number;
  policyType: string;
}

export interface Data {
  policies: Policy[];
}

export const getPolicies = async () => {
  const res = await http.get<ApiResponse<Data>>(`${baseUrl}/api/policies`);
  return res.data.data.policies;
};
